import type { TextFormatters } from '@zto/zpage'

/** 格式化省市区 */
export const formatters: TextFormatters = {
  fullAddress(val: string, options: any) {
    const data = options?.data || options?.model || options?.context?.data || {}
    if (!data) return val

    const { province, city, district } = data
    return `${province || ''} ${city || ''} ${district || ''} ${val || ''}`
  }
}
